import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import Logo from "../components/Logo";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { username: u, password: p });
      localStorage.setItem("bb_admin_token", r.data.token);
      toast.success("تم تسجيل الدخول");
      navigate("/admin");
    } catch {
      toast.error("بيانات الدخول غير صحيحة");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#040914] text-white flex items-center justify-center p-6" dir="rtl">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-[#0B1D3A]/80 border border-[#C5A059]/30 rounded-sm p-8"
        data-testid="admin-login-form"
      >
        <div className="flex flex-col items-center mb-6">
          <Logo className="h-16 w-16" />
          <div className="mt-3 text-[#C5A059] text-xs tracking-[0.3em]">لوحة التحكم</div>
        </div>

        <label className="block text-sm text-[#A1B0C6] mb-1">اسم المستخدم</label>
        <Input
          value={u}
          onChange={(e) => setU(e.target.value)}
          className="bg-[#040914] border-[#C5A059]/30 text-white mb-4 rounded-sm"
          data-testid="admin-username"
          required
        />

        <label className="block text-sm text-[#A1B0C6] mb-1">كلمة المرور</label>
        <Input
          type="password"
          value={p}
          onChange={(e) => setP(e.target.value)}
          className="bg-[#040914] border-[#C5A059]/30 text-white mb-6 rounded-sm"
          data-testid="admin-password"
          required
        />

        <Button
          type="submit"
          disabled={loading}
          className="w-full bg-[#C5A059] text-[#040914] hover:bg-[#E5C07B] font-bold py-6 rounded-sm"
          data-testid="admin-login-submit"
        >
          <Lock className="w-4 h-4 ml-2"/> دخول
        </Button>
      </form>
    </div>
  );
}
